import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import properties from "../api/properties";

const capitalizedUsername = (str) => {
    return String(str).charAt(0).toUpperCase() + String(str).slice(1);
}

const Dashboard = () => {
    const location = useLocation();
    const history = useNavigate();
    const data = location.state || {};
    const BASE_URL = properties.baseURL;

    const handleLogout = () => {
        history('/acsMbsaqip', {replace: true});
    };

    if (!data) {
        return <p>No data found. Please log in again.</p>;
    }

    let firstName = data.firstName;
    firstName = capitalizedUsername(firstName);
    let lastName = data.lastName;
    lastName = capitalizedUsername(lastName)
    let fileRequestedText;
    console.log(data);
    if (data.files !== undefined) {
        console.log(data.files.length);
    }
    if (data.files.length === 0) {
        fileRequestedText = 'No PUF files were found, as the timeframe to download the files has expired.';
    } else {
        fileRequestedText = 'The files requested are found below ready to be downloaded.';
    }

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="app-wrapper">
                <h2 className="mb-4 text-center">Welcome to PUF Bariatric Dashboard {firstName} {lastName}!</h2>
                <p className="text-center">{fileRequestedText}</p>
                <main className="app-main">
                    <table background-color="#eef1f6" cellSpacing="0" cellPadding="0" width="90%" border="0">
                        <tbody>
                        <tr>
                            <td width="50"></td>
                        </tr>
                        <tr>
                            <td width="300">
                                <table style={{width: "200px"}} width="499" align="center" border="0">
                                    <tbody>
                                    <tr>
                                        <td valign="top" align="left" width="632" height="100">
                                            <table width="860">
                                                <tbody>
                                                <tr>
                                                    <td><h1 style={{fontSize: "20px", color: "#1a3875"}}>File
                                                        List</h1>
                                                    </td>
                                                    <td align="right">
                                                        <button type="button" className="my-button"
                                                                onClick={handleLogout}>Logout
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>


                                            <table width="459" cellSpacing="1" cellPadding="2" border="0">
                                                <tbody>
                                                <tr>
                                                    <td>Year</td>
                                                    <td>Download</td>
                                                    <td>File Name</td>
                                                </tr>

                                                {data.files?.map((item) => (
                                                    <tr key={item.pfid} valign="top" align="left">
                                                        <td>{item.pufYear}</td>
                                                        <td>
                                                            <a
                                                                href={`${BASE_URL}/downloadPuf?requestedFileID=${item.pfid}`}
                                                                download>
                                                                {item.pufFileType} - {item.contentType}
                                                            </a>
                                                        </td>
                                                        <td>{item.pufFileName}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <br/><br/>
                                <div>
                                    <p>For assistance, please contact <a href="mailto: nsqiptech@facs.org"
                                                                         target="_blank">nsqiptech@facs.org</a></p>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </main>

            </div>
        </div>
    );
};

export default Dashboard;